/** Primeiro id_projeto selecionado no painel (sessionStorage), para ?id_projeto / política de idioma. */
export function readPrimaryProjectId() {
  try {
    const raw = sessionStorage.getItem("selectedCompanies");
    const arr = JSON.parse(raw);
    if (Array.isArray(arr) && arr.length) {
      const n = parseInt(arr[0], 10);
      if (Number.isFinite(n) && n > 0) return n;
    }
  } catch {
    /* ignore */
  }
  return null;
}
